import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBillingMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 128,
	height: 86,
	viewBox: "0 0 128 86",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 12C0 5.37258 5.37258 0 12 0H116C122.627 0 128 5.37258 128 12V74C128 80.6274 122.627 86 116 86H12C5.37258 86 0 80.6274 0 74V12Z",
			fill: "#01326F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75.4896 21.7739H51.8673V64.2265H75.4896V21.7739Z",
			fill: "#FF5F00"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.3672 43.0048C53.3628 38.9157 54.2889 34.8793 56.0754 31.2011C57.8619 27.5229 60.4619 24.2994 63.6785 21.7747C59.6958 18.6448 54.9128 16.6984 49.8763 16.1582C44.8397 15.6179 39.7528 16.5055 35.1969 18.7195C30.6409 20.9336 26.7998 24.3847 24.1124 28.6785C21.4251 32.9723 20 37.9356 20 43.001C20 48.0665 21.4251 53.0297 24.1124 57.3235C26.7998 61.6173 30.6409 65.0685 35.1969 67.2825C39.7528 69.4966 44.8397 70.3842 49.8763 69.8439C54.9128 69.3036 59.6958 67.3573 63.6785 64.2273C60.4628 61.7034 57.8635 58.4812 56.077 54.8044C54.2906 51.1276 53.3639 47.0926 53.3672 43.0048Z",
			fill: "#EB001B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M107.361 43.0037C107.361 48.0696 105.935 53.0331 103.248 57.3271C100.56 61.621 96.718 65.0721 92.1615 67.2859C87.605 69.4996 82.5175 70.3866 77.4807 69.8456C72.4439 69.3045 67.6609 67.3572 63.6785 64.2263C66.8928 61.7002 69.4915 58.477 71.2784 54.8C73.0653 51.123 73.9937 47.0882 73.9937 43C73.9937 38.9118 73.0653 34.877 71.2784 31.2C69.4915 27.523 66.8928 24.2998 63.6785 21.7737C67.6609 18.6428 72.4439 16.6955 77.4807 16.1544C82.5175 15.6134 87.605 16.5004 92.1615 18.7141C96.718 20.9279 100.56 24.379 103.248 28.6729C105.935 32.9669 107.361 37.9304 107.361 42.9963V43.0037Z",
			fill: "#F79E1B"
		})
	]
});
export default SvgBillingMastercard;
